import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRightIcon, StarIcon } from 'lucide-react';
import { useCart } from '../../contexts/CartContext';
import { getProduct } from '../../utils/products';
import { formatPrice } from '../../utils/currency';
import { images } from '../../data/images';
import type { Product } from '../../types/product';
import { Reveal } from '../ui/Reveal';
const roles = ['Reinigen', 'Scrubben', 'Behandelen', 'Opfrissen', 'Voeden'];
export function RitualSetFeature() {
  const {
    add
  } = useCart();
  const set = getProduct('hammam-ritueel-set');
  if (!set) return null;
  const variant = set.variants[0];
  const items = (set.includes ?? []).map(slug => getProduct(slug)).filter((p): p is Product => Boolean(p));
  return <section className="bg-berry text-white" data-id="element-97" data-mp="ntuyx17dzawc">
      <div className="grid lg:grid-cols-2" data-id="element-98" data-mp="srmqfu44cv00">
        <div className="relative min-h-[460px] lg:min-h-[820px]" data-id="element-99" data-mp="ssodyy2bn9ym">
          <img src={images.ritual} alt="Vrouw brengt rozenwater aan als verfrissende mist" className="absolute inset-0 h-full w-full object-cover" data-id="element-100" data-mp="xqzn16kslgfs" />
          <div className="absolute bottom-5 left-5 flex items-center gap-3 rounded-2xl bg-white p-2 pr-4 text-ink" data-id="element-101" data-mp="2fsionp6vpkxr">
            <img src={set.image} alt="" className="h-14 w-14 rounded-xl object-cover" data-id="element-102" data-mp="26tx7nyh22dz3" />
            <span className="text-sm" data-id="element-103" data-mp="21v3ts4xuwkye">
              <span className="block font-semibold" data-id="element-104" data-mp="21w5ihc7sp5yl">5 producten</span>
              <span className="block text-muted" data-id="element-105" data-mp="2yl4p6msqdzoo">in één doos</span>
            </span>
          </div>
        </div>

        <div className="flex flex-col justify-center px-6 py-16 sm:px-12 lg:px-20 lg:py-24" data-id="element-106" data-mp="2uj9i11o4cs2z">
          <Reveal data-id="element-107" data-mp="2psj8dc8nu32h">
            <p className="flex items-center gap-2 text-sm text-white/70" data-id="element-108" data-mp="2ps15vxvemsm4">
              <StarIcon className="h-4 w-4 fill-blush text-blush" strokeWidth={0} data-id="element-109" data-mp="2kuhs0z2mchup" />
              {set.rating.toLocaleString('nl-NL')} · {set.reviews} reviews · Bestseller
            </p>
            <h2 className="mt-5 font-display text-4xl uppercase leading-[0.98] tracking-display sm:text-6xl" data-id="element-110" data-mp="3dinaff679urd">
              Het hammam&shy;ritueel. <em className="italic text-blush" data-id="element-111" data-mp="ajarljl6qp1">In één doos.</em>
            </h2>
            <p className="mt-5 max-w-md text-lg text-white/75" data-id="element-112" data-mp="59491ffa30au">
              Vijf producten in de volgorde waarin je ze gebruikt. Zo weet je precies wat je doet en waarom.
            </p>
          </Reveal>

          <ol className="mt-10 border-t border-white/15" data-id="element-113" data-mp="3rndvvk3k809i">
            {items.map((p, i) => <li key={p.slug} className="border-b border-white/15" data-id="element-114" data-mp="3do4rrismowlw" data-mpi={i}>
                <Link to={`/product/${p.slug}`} className="group flex items-center gap-5 py-4" data-id="element-115" data-mp="3inhg67z5ebql">
                  <span className="w-6 text-sm text-white/45 tabular-nums" data-id="element-116" data-mp="34nptzjyh9p1i">0{i + 1}</span>
                  <span className="flex-1 text-lg font-medium transition-colors duration-150 group-hover:text-blush" data-id="element-117" data-mp="34q2jqjah93p4">{p.name}</span>
                  <span className="text-sm text-white/55" data-id="element-118" data-mp="12vtlkj7lwvay">{roles[i]}</span>
                  <ArrowUpRightIcon className="h-4 w-4 text-white/45 transition-colors duration-150 group-hover:text-blush" data-id="element-119" data-mp="16xy9r2faczq7" />
                </Link>
              </li>)}
          </ol>

          <div className="mt-10 flex flex-wrap items-center gap-x-8 gap-y-6" data-id="element-120" data-mp="2rdmp96h0guey">
            <p className="flex items-baseline gap-3" data-id="element-121" data-mp="2ng8cj4u4g4i7">
              <span className="text-4xl font-semibold tracking-tight" data-id="element-122" data-mp="31622jqhd4uti">{formatPrice(variant.price)}</span>
              {variant.compareAt && <span className="text-white/55 line-through" data-id="element-123" data-mp="2wdirp1a28dse">{formatPrice(variant.compareAt)}</span>}
            </p>
            <div className="flex flex-wrap gap-3" data-id="element-124" data-mp="3b257f43ln7k5">
              <button onClick={() => add(set.slug, variant.id)} className="inline-flex h-14 items-center whitespace-nowrap rounded-full bg-white px-8 text-base font-medium text-berry transition-colors duration-150 hover:bg-blush" data-id="element-125" data-mp="365ohc4cuaj4f">
                In winkelwagen
              </button>
              <Link to={`/product/${set.slug}`} className="inline-flex h-14 items-center whitespace-nowrap rounded-full border border-white/30 px-7 text-base font-medium transition-colors duration-150 hover:border-white" data-id="element-126" data-mp="1pr5ccd9fzzkk">
                Bekijk de set
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}